import { QuestionGroup } from './question-group.model';
import { Organization } from '../member/legal-entity.model';

export class Survey {

  createdAt?: string;
  description?: string;
  id?: number;
  isEnabled?: boolean;
  name?: string;
  organization?: Organization | string;
  questionGroups?: QuestionGroup[] | string[];
  topic?: string;
  updatedAt?: string;

  constructor(values= {}) {
    Object.assign(this, values);
  }
}
